import type { FC } from 'react';
import Tab from 'src/components/0200_tab';
import useAuth from 'src/hooks/auths/useAuth';
import BlueprintsHeader from './BlueprintsHeader';
import BranchHeader from './BranchHeader';
import CharacterHeader from './CharacterHeader';
import EventHeader from './EventHeader';
import EventsHeader from './EventsHeader';
import MechanicsHeader from './MechanicsHeader';
import OrganizationHeader from './OrganizationHeader';
import OrganizationSettingsHeader from './OrganizationSettingsHeader';
import PlayerHeader from './PlayerHeader';
import ReportsHeader from './ReportsHeader';

const Header: FC = () => {
  const { openModal, isRootUserValidated } = useAuth();

  if (!isRootUserValidated)
    return (
      <div className="flex justify-end pt-1">
        <div>
          <Tab label="Sign In" onClick={() => openModal({ modal: 'login' })} />
        </div>
      </div>
    );

  return (
    <div className="flex justify-end">
      <BranchHeader />
      <BlueprintsHeader />
      <CharacterHeader />
      <EventHeader />
      <EventsHeader />
      <MechanicsHeader />
      <OrganizationHeader />
      <OrganizationSettingsHeader />
      <PlayerHeader />
      <ReportsHeader />
    </div>
  );
};

export default Header;
